module.exports = __webpack_public_path__ + "img/mt4_sec6_3.7309fa13.png";